var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-border"},[_c('i',{staticClass:"overflow-arrow text-gray-900 fi-rr-arrow-right"}),_vm._v(" "),_c('div',{staticClass:"py-2 text-center"},[_c('h4',{staticClass:"text-dark-sky"},[_vm._v("Overall: "+_vm._s(_vm.overallScore)+"/"+_vm._s(_vm.biggestGrade.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }